import type { MouseEventHandler } from "react";
import CountTextInput from "./CountTextInput";
import type { UseFormRegister, FieldValues, Path } from "react-hook-form";
import { Button } from "./Button";

interface Props<T extends FieldValues & { zipcode: string; address1: string; address2: string } = FieldValues & { zipcode: string; address1: string; address2: string }> extends React.InputHTMLAttributes<HTMLInputElement> {
  zipCodeWatch: string;
  address1Watch: string;
  address2MaxLength: number;
  onZipCodeButtonClick: MouseEventHandler<HTMLButtonElement>;
  register: UseFormRegister<T>;
  errorMessage?: string;
}

const AddressInput = <T extends FieldValues & { zipcode: string; address1: string; address2: string } = FieldValues & { zipcode: string; address1: string; address2: string }>({
  zipCodeWatch,
  onZipCodeButtonClick,
  address1Watch,
  address2MaxLength,
  register,
  className,
  id,
  errorMessage,
  ...props
}: Props<T>) => {
  return (
    <>
      <div className="flex flex-col gap-[0.5rem]">
        <div className="flex flex-row / gap-[0.5rem]">
          <div
            className="bg-[#EAEAEA] border-[#D9D9D9] border-[0.0938rem]
                    / flex flex-row justify-between gap-3 / rounded-[8px] / p-[0.7188rem]
                    / min-h-[2.9375rem] w-[8.75rem]"
          >
            {zipCodeWatch || ""}
          </div>
          <input
            type="hidden"
            {...register("zipcode" as Path<T>, {
              required: {
                value: true,
                message: "필수 항목이에요",
              },
            })}
          />
          <Button
            onClick={onZipCodeButtonClick}
            className="w-[8.75rem]"
            variant="outline"
          >
            우편번호
          </Button>
        </div>
        <div
          className="bg-[#EAEAEA] border-[#D9D9D9] border-[0.0938rem]
                    / flex flex-row justify-between gap-3 / rounded-[8px] / p-[0.7188rem]
                    / min-h-[2.9375rem]"
        >
          {address1Watch || ""}
        </div>
        <input
          type="hidden"
          {...register("address1" as Path<T>, {
            required: {
              value: true,
              message: "필수 항목이에요",
            },
          })}
        />
        <CountTextInput
          errorMessage={errorMessage}
          {...register("address2" as Path<T>, {
            required: {
              value: false,
              message: "필수 항목이에요",
            },
          })}
          maxLength={address2MaxLength}
          className="bg-gray-50"
          placeholder="상세주소를 입력해 주세요."
        />
        <ul className="text-[0.75rem] text-[#757575]">
          <li>
            · 주소는 사업자 정보로 상시 노출됩니다. 거주지 주소와 사업장 주소가
            동일할 경우 유의해 주세요.
          </li>
        </ul>
      </div>
    </>
  );
};

export default AddressInput;
